import '../../main.css'
import '../../../App.css'
import { useCallback, useEffect, useRef, useState } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSortDown, faSortUp } from "@fortawesome/free-solid-svg-icons";
import { X, ShoppingBag, ChevronLeft, ReceiptText, RotateCcw, Trash2 } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import { changeShoppingFlag } from '../../../store';
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';

function Coupons_Header({ pageName = "", text = "", preLocation = "" }) {
    const { t } = useTranslation();

    const shoppingFlag = useSelector((state) => state.shoppingFlag.value);

    const menuItems = [
        { name: t('shopping_0'), link: '/shopping' },
        { name: t('shopping_3'), link: '/coupons' }
    ];
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const dropdownRef = useRef(null);
    const countries = [
        { name: '한국', code: 'KR', flag: '/img/south_korea.png' },
        { name: 'Philippines', code: 'PH', flag: '/img/Philippines.png' }
    ];

    const initialCountry = countries.find((c) => c.name === shoppingFlag) || countries[0];

    const [selectedCountry, setSelectedCountry] = useState(initialCountry);
    const [showDropdown, setShowDropdown] = useState(false);

    const toggleDropdown = () => setShowDropdown(!showDropdown);

    const handleSelect = (country) => {
        setSelectedCountry(country);
        dispatch(changeShoppingFlag(country.name));
        setShowDropdown(false);
    };

    // 드롭다운 외부 클릭 시 닫힘
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };

        if (showDropdown) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showDropdown]);

    const handleBack = () => {
        window.scrollTo({ top: 0, left: 0 });
        if (preLocation === 'coupons') {
            navigate('/coupons');
        } else {
            navigate('/shopping');
        }
    };

    return (
        <>
            <div
                style={{
                    position: 'fixed',
                    top: "0px",
                    left: "0px",
                    width: "100%",
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: "50px",
                    background: "#fff",
                    padding: "0 15px",
                    zIndex: "10",
                }}
            >
                <div ref={dropdownRef}>
                    <div
                        style={{
                            color: '#000',
                            // cursor: 'pointer',
                            position: 'absolute',
                            left: '15px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            display: 'flex',
                            alignItems: 'center',
                            gap: "6px",
                        }}
                    // onClick={toggleDropdown}
                    >
                        <img src={'/jciImg/jci_logo_icon.png'} style={{ width: "30px", padding: "2px",boxShadow: '0 2px 6px rgba(0,0,0,0.2)', backgroundColor: "#000",borderRadius: "50%" }} />
                        {/* <img src={selectedCountry.flag} alt={selectedCountry.name} style={{ width: "28px", boxShadow: '0 2px 6px rgba(0,0,0,0.2)', borderRadius: "50%" }} /> */}
                        {/* {
                            showDropdown
                                ?
                                <FontAwesomeIcon icon={faSortUp} style={{ paddingTop: "5px", fontSize: "20px" }} />
                                :
                                <FontAwesomeIcon icon={faSortDown} style={{ paddingBottom: "5px", fontSize: "20px" }} />
                        } */}
                    </div>

                    {showDropdown && (
                        <div
                            style={{
                                position: 'absolute',
                                top: 'calc(100% - 7px)',
                                left: '10px',
                                background: 'white',
                                border: '1px solid #ccc',
                                borderRadius: '4px',
                                padding: '10px',
                                boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                                zIndex: "10",
                                fontSize: "15px",
                            }}
                        >
                            {countries.map((country) => (
                                <div
                                    key={country.code}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '5px',
                                        cursor: 'pointer',
                                        padding: '5px 10px 5px 5px',
                                        backgroundColor: country.name === shoppingFlag ? '#f0f0f0' : 'transparent',
                                        borderRadius: '4px',
                                        height: "40px"
                                    }}
                                    onClick={() => handleSelect(country)}
                                >
                                    <img src={country.flag} alt={country.name} style={{ width: '32px' }} />
                                    <span>{country.name}</span>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                {/* 중앙 타이틀 */}
                <div style={{ fontWeight: 'bold', color: "#000", fontSize: "18px" }}>
                    {t(text)}
                </div>
                {
                    text == "shopping_4"
                        ?
                        <div
                            style={{
                                color: '#000',
                                cursor: 'pointer',
                                position: 'absolute',
                                right: '5px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                display: 'flex',
                                alignItems: 'center',
                                gap: "10px"
                            }}
                        >
                            {/* <i className="fa-brands fa-telegram" style={{ fontSize: '27px', color: "#0088cc" }}
                                onClick={() => window.open('https://t.me/jciyeouido_bot', '_blank')}></i> */}

                            <ReceiptText size={38} style={{ padding: "7px" }}
                                onClick={() => {
                                    window.scrollTo({ top: 0, left: 0 });
                                    navigate('/shoppingHistory', { state: { pre_location: pageName == t('shopping_3') ? "coupons" : "shopping" } })
                                }} />
                        </div>
                        :
                        <div
                            style={{
                                color: '#000',
                                cursor: 'pointer',
                                position: 'absolute',
                                right: '10px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                display: 'flex',
                                alignItems: 'center',
                            }}
                            onClick={handleBack}
                        >
                            <X style={{ width: '28px', height: '28px' }} />
                        </div>
                }
            </div>
            {
                text == "shopping_4"
                    ?
                    <nav className="shopping-nav">
                        <ul>
                            {menuItems.map((item) => (
                                <li
                                    key={item.name}
                                    className={pageName === item.name ? 'active' : ''}
                                    onClick={() => { navigate(item.link) }}
                                >
                                    {item.name}
                                </li>
                            ))}
                        </ul>
                    </nav>
                    :
                    ""
            }
        </>
    );
}


export default Coupons_Header;